const BASE_URL = "https://diagramplus.com";

export const Config = { BASE_URL };
